/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ap-destination-list{overflow-y:scroll;height:80vh}.ap-destination-list .mat-pseudo-checkbox{display:none}"];
export { styles as styles };
